import { render, staticRenderFns } from "./DocumentSignersSection.vue?vue&type=template&id=3e7914fb"
import script from "./DocumentSignersSection.vue?vue&type=script&lang=js"
export * from "./DocumentSignersSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports